import React from 'react';
import { Grid } from '@mui/material';
import PluginAuthenticationModal from 'components/CreateSpark/SparkBuilderDrawers/RightDrawer/forms/PluginFunctions/PluginConnectionAuthentication/PluginAuthenticationModal';
import { WorkSpaceIcon } from 'components/SVG';
import { SparkDialog, SparkTruncatedTypography } from 'sharedComponents/UI';
import type { PluginAuthentication } from 'types/PluginAuthentications';
import type { Plugins } from 'types/Plugins';
import { PluginsFormType } from 'components/CreateSpark/SparkBuilderDrawers/RightDrawer/forms/PluginFunctions/PluginsFormContainer';
import { useFormikContext } from 'formik';

type AddConnectionPluginAuthenticationProps = {
  pluginAuthentications: PluginAuthentication[];
  selectedPlugin: {
    plugin: Plugins | undefined;
    pluginConnections: number | undefined;
    pluginAuthentications: PluginAuthentication[] | undefined;
  };
  isModalOpen: boolean;
  handleClose: () => void;
};

function AddConnectionPluginAuthentication({
  pluginAuthentications,
  selectedPlugin,
  isModalOpen,
  handleClose,
}: AddConnectionPluginAuthenticationProps) {
  const [pluginAuthenticationID, setPluginAuthenticationID] = React.useState<
    string | null
  >(null);
  const [isSelectDialogOpen, setIsSelectDialogOpen] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    const totalPluginConnections = pluginAuthentications.length;

    if (totalPluginConnections === 1) {
      setPluginAuthenticationID(pluginAuthentications[0].id);
      setIsSelectDialogOpen(false);
    } else if (totalPluginConnections > 1) {
      setIsSelectDialogOpen(true);
    }
  }, [pluginAuthentications]);

  const handleSelectAuthentication = (authenticationID: string) => {
    setPluginAuthenticationID(authenticationID);
    setIsSelectDialogOpen(false);
  };

  return (
    <SparkDialog
      title={
        isSelectDialogOpen
          ? 'Select Plugin Authentication'
          : 'Add Plugin Connection'
      }
      open={isModalOpen}
      onClose={handleClose}
    >
      {isSelectDialogOpen ? (
        <>
          {pluginAuthentications.map((authentication) => (
            <Grid
              container
              border={(theme) => `1px solid ${theme.palette.borderColor}`}
              alignItems='center'
              borderRadius='10px'
              sx={{ cursor: 'pointer', flexWrap: 'nowrap' }}
              padding={1.5}
              gap={2}
              onClick={() => handleSelectAuthentication(authentication.id)}
              mb={'10px'}
            >
              <Grid item>
                <WorkSpaceIcon />
              </Grid>
              <Grid item display='flex' gap={1} flexDirection='column'>
                <SparkTruncatedTypography
                  typographyProps={{
                    variant: 'body1',
                    fontFamily: 'Mont-SemiBold',
                    sx: {
                      wordBreak: 'break-word',
                    },
                  }}
                >
                  {authentication.attributes.name}
                </SparkTruncatedTypography>
              </Grid>
            </Grid>
          ))}
        </>
      ) : (
        pluginAuthenticationID && (
          <PluginAuthenticationModal
            isOpen={isModalOpen && !isSelectDialogOpen}
            onClose={handleClose}
            selectedPlugins={selectedPlugin.plugin}
            pluginAuthenticationID={pluginAuthenticationID}
            pluginConnection={null}
            onCreatePluginConnection={() => {}}
          />
        )
      )}
    </SparkDialog>
  );
}

export default AddConnectionPluginAuthentication;
